import React from 'react';
export function TermsContent() {
  return <div className="prose prose-stone max-w-none" data-id="element-232">
      <p className="text-stone-600 mb-6" data-id="element-233">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section className="mb-8" data-id="element-234">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-235">
          1. Aceptación de Términos
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-236">
          Al adquirir "Puentes de Palabras", aceptas estos términos y
          condiciones en su totalidad. Si no estás de acuerdo con alguna parte
          de estos términos, no debes realizar la compra.
        </p>
      </section>

      <section className="mb-8" data-id="element-237">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-238">
          2. Descripción del Producto
        </h3>
        <p className="text-stone-700 leading-relaxed mb-4" data-id="element-239">
          "Puentes de Palabras" es un producto digital (ebook) que incluye:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-stone-700" data-id="element-240">
          <li data-id="element-241">Ebook completo en formato PDF</li>
          <li data-id="element-242">Plantilla del Diccionario Familiar</li>
          <li data-id="element-243">30 Frases de Rescate</li>
          <li data-id="element-244">Checklist "Antes de llamar"</li>
        </ul>
        <p className="text-stone-700 leading-relaxed mt-4" data-id="element-245">
          Este es un producto educativo e informativo. No sustituye
          asesoramiento profesional psicológico o terapéutico.
        </p>
      </section>

      <section className="mb-8" data-id="element-246">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-247">
          3. Compra y Pago
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-248">
          El precio del producto es de $6.39 USD (precio promocional, antes
          $19.99 USD). El pago se procesa de forma segura a través de nuestro
          proveedor de pagos. Una vez completado el pago, recibirás acceso
          inmediato al producto digital en tu correo electrónico.
        </p>
      </section>

      <section className="mb-8" data-id="element-249">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-250">
          4. Entrega del Producto
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-251">
          El producto digital se entrega inmediatamente después de confirmar el
          pago, mediante un enlace de descarga enviado a tu correo electrónico.
          Es tu responsabilidad proporcionar una dirección de correo válida y
          verificar tu bandeja de entrada (incluyendo spam).
        </p>
      </section>

      <section className="mb-8" data-id="element-252">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-253">
          5. Propiedad Intelectual
        </h3>
        <p className="text-stone-700 leading-relaxed mb-4" data-id="element-254">
          Todo el contenido de "Puentes de Palabras" está protegido por derechos
          de autor. Al adquirir el producto, obtienes una licencia personal, no
          transferible, para:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-stone-700" data-id="element-255">
          <li data-id="element-256">Usar el material para tu beneficio personal</li>
          <li data-id="element-257">Imprimir una copia para uso personal</li>
        </ul>
        <p className="text-stone-700 leading-relaxed mt-4 font-semibold" data-id="element-258">
          NO está permitido:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-stone-700" data-id="element-259">
          <li data-id="element-260">Compartir, distribuir o revender el contenido</li>
          <li data-id="element-261">Publicar el material en línea o en redes sociales</li>
          <li data-id="element-262">Modificar o crear obras derivadas sin autorización</li>
          <li data-id="element-263">Usar el contenido con fines comerciales</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-264">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-265">
          6. Limitación de Responsabilidad
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-266">
          "Puentes de Palabras" es un recurso educativo. No garantizamos
          resultados específicos, ya que cada situación familiar es única. El
          producto no sustituye terapia profesional, especialmente en casos de
          violencia, abuso o problemas de salud mental graves.
        </p>
      </section>

      <section className="mb-8" data-id="element-267">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-268">
          7. Soporte Técnico
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-269">
          Ofrecemos soporte técnico para problemas de descarga o acceso al
          producto. Para consultas sobre el contenido, consulta el material
          incluido en el ebook.
        </p>
      </section>

      <section className="mb-8" data-id="element-270">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-271">
          8. Modificaciones
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-272">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación. Tu uso continuado del producto después de cualquier
          cambio constituye tu aceptación de los nuevos términos.
        </p>
      </section>

      <section data-id="element-273">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-274">
          9. Ley Aplicable
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-275">
          Estos términos se rigen por las leyes aplicables en tu jurisdicción.
          Cualquier disputa se resolverá mediante arbitraje o en los tribunales
          competentes.
        </p>
      </section>
    </div>;
}